import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import {getAuth} from 'firebase/auth';
import {createRoot} from 'react-dom/client';
import {Page} from './Page';

console.log('Starting...');

const firebaseConfig = {
  apiKey: 'AIzaSyCaYUpFjEJXTtXqXgGG7IXhc_KgbY3bhb4',
  authDomain: 'chase-and-halen.firebaseapp.com',
  projectId: 'chase-and-halen',
  storageBucket: 'chase-and-halen.firebasestorage.app',
  messagingSenderId: '321978025174',
  appId: '1:321978025174:web:29eb0d64dc4aa56d5db577'
};

const app = initializeApp(firebaseConfig);
const database = getFirestore(app);
const auth = getAuth(app);

const root = createRoot(document.getElementById('app-mount'));

root.render(<Page auth={auth} database={database}/>);

console.log('Started!')
